import { jsx as o } from "react/jsx-runtime";
import { twMerge as t } from "tailwind-merge";
import { SocialLinksEnum as n } from "../enums/social-links-enum.mjs";
import i from "../icons/social-links/discord-icon.mjs";
import a from "../icons/social-links/email-icon.mjs";
import s from "../icons/social-links/etsy-icon.mjs";
import p from "../icons/social-links/facebook-icon.mjs";
import f from "../icons/social-links/instagram-icon.mjs";
import m from "../icons/social-links/link-icon.mjs";
import u from "../icons/social-links/linkedin-icon.mjs";
import I from "../icons/social-links/pinterest-icon.mjs";
import k from "../icons/social-links/snapchat-icon.mjs";
import l from "../icons/social-links/spotify-icon.mjs";
import h from "../icons/social-links/telegram-icon.mjs";
import w from "../icons/social-links/tiktok-icon.mjs";
import b from "../icons/social-links/twitch-icon.mjs";
import d from "../icons/social-links/twitter-icon.mjs";
import g from "../icons/social-links/vimeo-icon.mjs";
import y from "../icons/social-links/whatsapp-icon.mjs";
import x from "../icons/social-links/youtube-icon.mjs";
const e = "w-[20px] h-[20px] shrink-0", H = (c, r) => {
  switch (c) {
    case n.instagram:
      return /* @__PURE__ */ o(f, { className: t(e, r) });
    case n.pinterest:
      return /* @__PURE__ */ o(I, { className: t(e, r) });
    case n.telegram:
      return /* @__PURE__ */ o(h, { className: t(e, r) });
    case n.vimeo:
      return /* @__PURE__ */ o(g, { className: t(e, r) });
    case n.twitter:
      return /* @__PURE__ */ o(d, { className: t(e, r) });
    case n.facebook:
      return /* @__PURE__ */ o(p, { className: t(e, r) });
    case n.spotify:
      return /* @__PURE__ */ o(l, { className: t(e, r) });
    case n.linkedin:
      return /* @__PURE__ */ o(u, { className: t(e, r) });
    case n.youtube:
      return /* @__PURE__ */ o(x, { className: t(e, r) });
    case n.tiktok:
      return /* @__PURE__ */ o(w, { className: t(e, r) });
    case n.discord:
      return /* @__PURE__ */ o(i, { className: t(e, r) });
    case n.etsy:
      return /* @__PURE__ */ o(s, { className: t(e, r) });
    case n.snapchat:
      return /* @__PURE__ */ o(k, { className: t(e, r) });
    case n.website:
      return /* @__PURE__ */ o(m, { className: t(e, r) });
    case n.twitch:
      return /* @__PURE__ */ o(b, { className: t(e, r) });
    case n.email:
      return /* @__PURE__ */ o(a, { className: t(e, r) });
    case n.whatsapp:
      return /* @__PURE__ */ o(y, { className: t(e, r) });
    default:
      return /* @__PURE__ */ o(m, { className: t(e, r) });
  }
};
export {
  H as getSocialLinkIcon
};
